module.exports = __webpack_public_path__ + "img/expire_coupon.8cf36b06.png";